// @ts-ignore
import crossIllustration from "../../../../assets/ilustraciones/cruce.svg";
import { ActionBar, ActionButton, Eyebrow, ScreenLead, ScreenTitle } from "../OnboardingShell";

/** Tras "Lo hago después": dónde subir los documentos y qué hacemos con ellos. */
export function DocumentsLaterStep({
  onContinue,
  onBack,
}: {
  onContinue: () => void;
  onBack: () => void;
}) {
  return (
    <div className="mx-auto w-full max-w-[620px]">
      {/* El tono del círculo de las demás ilustraciones, para que se funda con el panel. */}
      <div className="mb-6 flex h-40 items-center justify-center rounded-[20px] bg-[#E3ECF8] sm:h-48">
        <img src={crossIllustration} alt="" className="h-full w-auto" />
      </div>
      <Eyebrow tone="blue">Tus documentos</Eyebrow>
      <ScreenTitle>Cuando los tengas, te decimos en cuáles calificas.</ScreenTitle>
      <ScreenLead>
        Súbelos cuando quieras en Configuración → Documentos. Los cruzamos con las bases de tus
        licitaciones, requisito por requisito.
      </ScreenLead>
      <ActionBar onBack={onBack}>
        <ActionButton tone="blue" onClick={onContinue} arrow>
          Continuar
        </ActionButton>
      </ActionBar>
    </div>
  );
}
